import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const SnackbarWarningIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 45 45'
      data-test-id='snackbar-warning-icon'
    >
      <path
        d='M20.4034 6.97788C21.3892 5.46023 23.6108 5.46023 24.5966 6.97788L39.4773 29.8882C40.5575 31.5514 39.3639 33.75 37.3807 33.75H7.61926C5.63605 33.75 4.44243 31.5514 5.5227 29.8882L20.4034 6.97788Z'
        className='background'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M22.5 12.9167C21.3494 12.9167 20.4167 13.8494 20.4167 15V22.5C20.4167 23.6506 21.3494 24.5833 22.5 24.5833C23.6506 24.5833 24.5833 23.6506 24.5833 22.5V15C24.5833 13.8494 23.6506 12.9167 22.5 12.9167ZM22.5 26.25C21.3494 26.25 20.4167 27.1827 20.4167 28.3333C20.4167 29.4839 21.3494 30.4167 22.5 30.4167C23.6506 30.4167 24.5833 29.4839 24.5833 28.3333C24.5833 27.1827 23.6506 26.25 22.5 26.25Z'
        className='content'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M28.7897 4.25436L43.6704 27.1647C46.9112 32.1542 43.3303 38.75 37.3807 38.75H7.61927C1.66962 38.75 -1.91124 32.1542 1.32956 27.1647L16.2103 4.25436C19.1675 -0.298588 25.8325 -0.298597 28.7897 4.25436ZM24.5966 6.97788C23.6108 5.46023 21.3892 5.46023 20.4034 6.97788L5.5227 29.8882C4.44243 31.5514 5.63605 33.75 7.61927 33.75H37.3807C39.3639 33.75 40.5575 31.5514 39.4773 29.8882L24.5966 6.97788Z'
        className='outline'
      />
    </SvgIcon>
  );
};

export default SnackbarWarningIcon;
